enum PensionAgreementValuationType {
  BALANCE = 'BALANCE',
  BENEFIT = 'BENEFIT',
  NONE = 'NONE',
}

export default PensionAgreementValuationType;
